var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: _vm.dialogWidth },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.onenter.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "resizable-card",
          class: { "no-select": _vm.resizing },
          style: { height: _vm.dialogHeight + "px" },
        },
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [
              _vm._v("Card Album Config"),
            ]),
          ]),
          _c(
            "v-card-text",
            { staticClass: "resizable-card__body" },
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Name:" },
                        model: {
                          value: _vm.model.name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Key:" },
                        model: {
                          value: _vm.model.key,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "key",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.key",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-expansion-panels",
                { staticClass: "mt-6" },
                [
                  _c("r-card-panel", {
                    attrs: { items: _vm.model.cards, title: "Cards" },
                    on: {
                      "update:items": function ($event) {
                        return _vm.$set(_vm.model, "cards", $event)
                      },
                    },
                  }),
                  _c("r-reward-bunch-panel", {
                    attrs: { model: _vm.model.rewardBunch, title: "Rewards" },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.model, "rewardBunch", $event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "resizable-card__actions" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
          _c("div", {
            staticClass: "resize-handle",
            on: {
              mousedown: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.startResize.apply(null, arguments)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }